import { take, fork, all, call, takeEvery } from 'redux-saga/effects';
import { apiTask, watchApiTask } from '../../app/sagas';
import { api } from '../../app/api';
import { success } from '../../app/actions';
import * as actions from './editClassActions';

export const undoDeleteStudentTask = watchApiTask(
  actions.UNDO_DELETE_STUDENT,
  api.post,
  '/evaluation-system/undoRemoveStudent.php',
);

export const addStudentTask = watchApiTask(
  actions.ADD_STUDENT,
  api.post,
  '/evaluation-system/addStudent.php',
);

export const editStudentTask = watchApiTask(
  actions.EDIT_STUDENT,
  api.post,
  '/evaluation-system/editStudent.php',
);

export const getSchoolsTask = apiTask(
  actions.GET_SCHOOLS,
  api.post,
  '/evaluation-system/getSchools.php',
);

export const getClassesTask = apiTask(
  actions.GET_CLASSES,
  api.post,
  '/evaluation-system/getFilteredCatalogings.php',
);

export const getLevelsTask = apiTask(
  actions.GET_LEVELS,
  api.post,
  '/evaluation-system/getFilteredCatalogings.php',
);

export const getPeriodsTask = apiTask(
  actions.GET_PERIODS,
  api.post,
  '/evaluation-system/getGroupsPeriod.php',
);

export const editGroupTask = apiTask(
  actions.EDIT_GROUP,
  api.post,
  '/evaluation-system/editGroup.php',
);

export const addGroupTask = apiTask(actions.ADD_GROUP, api.post, '/evaluation-system/addGroup.php');

export const getGroupInformationTask = apiTask(
  actions.GET_GROUP_INFORMATION,
  api.post,
  '/evaluation-system/getGroupInformation.php',
);

export const deleteStudentTask = apiTask(
  actions.DELETE_STUDENT,
  api.post,
  '/evaluation-system/removeStudent.php',
);

export const getGroupsTask = apiTask(
  actions.GET_GROUPS,
  api.post,
  '/evaluation-system/getGroups.php',
);

export function* watchDeleteStudentTask() {
  while (true) {
    const { payload, meta } = yield take(actions.DELETE_STUDENT);
    yield fork(deleteStudentTask, payload, { meta });
  }
}

export function* watchGetClasses() {
  while (true) {
    const { payload } = yield take(actions.GET_CLASSES);
    yield fork(getClassesTask, payload);
  }
}

export function* watchGetSchools() {
  while (true) {
    const { payload } = yield take(actions.GET_SCHOOLS);
    const response = yield call(getSchoolsTask, payload);
    if (response.data && response.data.content && response.data.content.length === 1) {
      yield fork(getLevelsTask, {
        idCSchool: response.data.content[0].idCSchool,
        catalogingType: 'segment',
      });
    }
  }
}

export function* watchGetLevels() {
  while (true) {
    const { payload } = yield take(actions.GET_LEVELS);
    yield fork(getLevelsTask, payload);
  }
}

export function* watchGetPeriods() {
  while (true) {
    const { payload } = yield take(actions.GET_PERIODS);
    yield fork(getPeriodsTask, payload);
  }
}

export function* watchGetGroupInformation() {
  while (true) {
    const { payload } = yield take(actions.GET_GROUP_INFORMATION);
    const result = yield call(getGroupInformationTask, payload);
    if (result.data && result.data.content) {
      yield fork(getLevelsTask, {
        idCSchool: result.data.content.idCSchool,
        catalogingType: 'segment',
      });
      yield fork(getClassesTask, {
        idCSchool: result.data.content.idCSchool,
        catalogingType: 'level',
        idCatalogingSegment: result.data.content.idCatalogingSegment,
      });
    }
  }
}

export function* watchEditGroup() {
  while (true) {
    const { payload } = yield take(actions.EDIT_GROUP);
    yield fork(editGroupTask, payload);
  }
}

export function* watchAddGroup() {
  while (true) {
    const { payload } = yield take(actions.ADD_GROUP);
    yield fork(addGroupTask, payload);
  }
}

export function* watchGetGroups() {
  yield takeEvery(actions.GET_GROUPS, getGroupsTask);
}

// Root module saga
export function* sagas() {
  yield all([
    fork(watchGetGroups),
    fork(watchGetGroupInformation),
    fork(watchEditGroup),
    fork(watchGetLevels),
    fork(watchGetPeriods),
    fork(watchGetSchools),
    fork(watchGetClasses),
    fork(watchAddGroup),
    fork(undoDeleteStudentTask),
    fork(editStudentTask),
    fork(watchDeleteStudentTask),
    fork(addStudentTask),
  ]);
}
